var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCabbage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_283)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_283",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 61
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.500004H60.5V60.5H0.5V0.500004Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_283)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7062 57.6979C28.0411 56.0472 29.7391 51.2676 38.1603 51.4681C38.1603 51.4681 39.1826 42.2845 44.6039 39.9328C44.3522 39.2236 44.2146 38.46 44.2146 37.6643C44.2146 34.171 46.856 31.2948 50.2504 30.9239C50.4951 30.8972 50.7437 30.8834 50.9954 30.8834C52.2774 30.8834 53.4762 31.2391 54.4986 31.8573C56.4631 33.0449 57.7763 35.2011 57.7763 37.6643C57.7763 41.3349 54.8595 44.3239 51.2174 44.4411C50.0157 53.8514 42.3449 62.4075 27.6258 58.2488C27.6258 58.2488 27.6365 58.0409 27.7062 57.6979Z",
    fill: "#73CA5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9291 43.7744C25.9987 49.1751 27.6258 58.2489 27.6258 58.2489C14.9866 58.2489 4.74039 47.6233 4.74039 34.516C4.74039 31.2985 5.35914 28.2312 6.47769 25.4332C6.44523 25.6754 4.97382 37.0466 15.1539 41.5391C16.5584 42.1588 17.8117 42.9208 18.9291 43.7744Z",
    fill: "#A6F074"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.607 33.3052C20.9661 35.727 18.929 43.7743 18.929 43.7743C17.8117 42.9207 16.5583 42.1587 15.154 41.5391C4.97377 37.0466 6.44518 25.6753 6.47764 25.4332L6.47658 25.4325C0.513967 21.4249 3.88346 16.3771 7.57311 16.6332L7.57299 16.6343C8.68533 16.7114 9.82674 17.2698 10.7503 18.4848L10.751 18.4855L10.7517 18.4862C12.7803 20.4905 12.7323 23.8605 12.7323 23.8605C16.7891 26.5152 16.607 33.3052 16.607 33.3052Z",
    fill: "#73CA5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2467 30.898C48.6558 20.1125 40.0641 11.7168 29.4322 10.8559C29.4322 10.8559 32.0165 6.37113 38.7182 8.13445L38.7193 8.13328C40.171 8.51554 41.8161 9.19102 43.6699 10.2688C43.6699 10.2688 49.2398 7.84711 51.4193 13.7803C58.5609 14.4013 59.4695 22.0767 55.052 26.4943C55.052 26.4943 56.367 28.5019 54.4986 31.8573C53.4762 31.239 52.2774 30.8834 50.9955 30.8834C50.7436 30.8834 50.4951 30.8975 50.2505 30.9244C50.2491 30.9155 50.2479 30.9067 50.2467 30.898Z",
    fill: "#A6F074"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2467 30.898C50.2479 30.9067 50.2491 30.9155 50.2504 30.9239C46.856 31.2948 44.2145 34.1711 44.2145 37.6642C44.2145 38.4599 44.3521 39.2235 44.604 39.9328C39.1825 42.2844 38.1603 51.4681 38.1603 51.4681C29.7391 51.2676 28.0411 56.0472 27.7061 57.6979C27.6366 58.0409 27.6258 58.2489 27.6258 58.2489C27.6258 58.2489 25.9987 49.1751 18.9291 43.7744C18.9291 43.7744 20.9662 35.7271 16.6069 33.3053C16.6069 33.3053 16.789 26.5152 12.7322 23.8606C12.7322 23.8606 12.7803 20.4906 10.7518 18.4862C14.9352 13.7521 20.9457 10.783 27.6258 10.783C28.2338 10.783 28.836 10.8086 29.432 10.8573C40.0638 11.7184 48.6558 20.1127 50.2467 30.898Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7193 8.13328C38.7193 8.13328 37.1311 1.67156 29.6239 1.67156C22.1166 1.67156 21.1479 6.99937 21.1479 6.99937C21.1479 6.99937 8.75513 5.68277 7.57318 16.6332L7.57306 16.6343C8.6854 16.7114 9.82669 17.2698 10.7504 18.4848L10.7518 18.4862C14.9352 13.7521 20.9457 10.7829 27.6258 10.7829C28.2338 10.7829 28.836 10.8086 29.432 10.8573L29.4322 10.8558C29.4322 10.8558 32.0165 6.37113 38.7182 8.13445L38.7193 8.13328Z",
    fill: "#73CA5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4322 10.8559C29.4322 10.8559 33.2563 4.21454 43.6698 10.2688C43.6698 10.2688 49.2398 7.84711 51.4193 13.7803C58.5609 14.4013 59.4695 22.0767 55.052 26.4943C55.052 26.4943 56.367 28.5019 54.4986 31.8573L54.4984 31.8574C53.4761 31.2393 52.2774 30.8834 50.9955 30.8834C50.7436 30.8834 50.4951 30.8975 50.2505 30.9244C48.6698 20.1263 40.0724 11.7191 29.432 10.8574L29.4322 10.8559Z",
    stroke: "black",
    strokeWidth: 2.46094,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59918 49.1386C13.7882 54.6846 20.3057 58.2488 27.6258 58.2488C27.6258 58.2488 27.9891 51.226 38.1604 51.4681C38.1604 51.4681 39.1825 42.2844 44.6039 39.9327C44.3522 39.2235 44.2146 38.4599 44.2146 37.6642C44.2146 34.1711 46.8561 31.2953 50.2506 30.9243C48.5816 19.5245 39.0239 10.6355 27.3349 10.7849M7.69958 46.1967C7.7093 46.2144 7.71903 46.2321 7.72864 46.2498M6.47766 25.4332C5.35911 28.2312 4.74036 31.2985 4.74036 34.516C4.74036 37.0201 5.11454 39.4339 5.8077 41.6999M19.2394 12.4273C15.9768 13.7607 13.0805 15.8496 10.751 18.4855M22.4044 11.4035C22.3991 11.4048 22.3938 11.4062 22.3886 11.4074",
    stroke: "black",
    strokeWidth: 2.46094,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 26.5C49 26.5 14.5905 32.7461 29.9466 57.5",
    stroke: "black",
    strokeWidth: 2.46094,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6258 58.2488C27.6258 58.2488 25.4437 46.0799 15.1539 41.539C4.97382 37.0465 6.44523 25.6752 6.47769 25.4332",
    stroke: "black",
    strokeWidth: 2.46094,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9954 30.8833C47.2505 30.8833 44.2146 33.9192 44.2146 37.6642C44.2146 38.4599 44.3522 39.2235 44.6039 39.9328C39.1825 42.2844 38.1604 51.468 38.1604 51.468C27.9891 51.2259 27.6258 58.2488 27.6258 58.2488C42.3449 62.4075 50.0158 53.8513 51.2174 44.441C54.8596 44.3238 57.7763 41.3349 57.7763 37.6642C57.7763 33.9192 54.7404 30.8833 50.9954 30.8833Z",
    stroke: "black",
    strokeWidth: 2.46094,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.607 33.3052C20.9661 35.727 18.9291 43.7743 18.9291 43.7743C17.8239 42.93 16.5854 42.1753 15.1996 41.5593L15.154 41.5391C4.97378 37.0466 6.44519 25.6753 6.47765 25.4332C6.47765 25.4332 6.47741 25.4329 6.47659 25.4325C-1.28356 20.2168 6.763 13.2392 10.7503 18.4848C12.7805 20.4891 12.7323 23.8605 12.7323 23.8605C16.7891 26.5152 16.607 33.3052 16.607 33.3052Z",
    stroke: "black",
    strokeWidth: 2.46094,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7182 8.13445L38.7193 8.13328C38.7193 8.13328 37.1311 1.67168 29.6239 1.67168C22.1166 1.67168 21.1478 6.99937 21.1478 6.99937C21.1478 6.99937 8.75501 5.68277 7.57318 16.6332L7.57306 16.6343C8.6854 16.7114 9.82669 17.2698 10.7504 18.4848L10.7518 18.4862",
    stroke: "black",
    strokeWidth: 2.46094,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15.5C16.5805 16.0067 16.7851 21.9372 21.6426 23.7186M20.5 40C18.5 28 24 30 21.6426 23.7186M21.6426 23.7186C26.5 25.5 27 39 27 39C28.2752 23.8762 29.6542 20.0456 35 21.5M21.6426 23.7186C21.6426 23.7186 18 13.5 22.5 11.5C27 9.5 35 21.5 35 21.5M35 21.5L45 20C44.2337 19.5913 35.9676 21.7633 35 21.5Z",
    stroke: "black",
    strokeWidth: 2.46094,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4129 39.1728C29.9552 39.1688 26.876 40.1186 26.158 43.1382M35.4483 39.9313C35.4346 39.9181 35.4203 39.9052 35.4051 39.8924",
    stroke: "black",
    strokeWidth: 2.46094,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1479 6.9995L22.3787 7.97766",
    stroke: "black",
    strokeWidth: 2.46094,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1603 51.4681C39.953 51.4506 41.2991 51.8234 42.1542 52.6261",
    stroke: "black",
    strokeWidth: 2.46094,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7322 23.8606C12.7322 23.8606 11.898 26.6765 12.2495 30.1042",
    stroke: "black",
    strokeWidth: 2.46094,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4193 13.7802C51.4193 13.7802 49.0613 13.7454 47.6927 15.0481",
    stroke: "black",
    strokeWidth: 2.46094,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2173 44.441C51.2173 44.441 51.4303 40.8358 51.9576 39.869",
    stroke: "black",
    strokeWidth: 2.46094,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabbage);
export default __webpack_public_path__ + "static/media/cabbage.cb589fd3016a865e39560b3443ae0417.svg";
export { ForwardRef as ReactComponent };